<template>
  <div :class="{'has-logo':showLogo}">
    <el-scrollbar wrap-class="scrollbar-wrapper">
    <logo  :collapse="isCollapse" />

      <!-- <img style="width:100%;height:100%;display:block;margin:auto;margin-top: 10px;"  src="@/images/logo_menu.png" alt=""> -->
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in routes" :key="route.uri" :item="route" :base-path="route.uri" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  data(){
    return{
      routes:[]
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    // routes() {
    //   return this.routes
    // },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      console.log('path',path,route,meta)
      if (meta.activeMenu) {
        if(meta.activeMenu=='fhxy'){
          if(route.query.menu_type=="user_id"){
            return '/evaluate/userid'
          }else if(route.query.menu_type=="ratee"){
            return '/evaluate/ratee'
          }else{
            return '/noted/notedInfo'
          }

        }
        return meta.activeMenu
      }
     
      
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods:{
    getRouter(){
      let sidebarStr = localStorage.getItem('sidebarList')
      if(sidebarStr){
        this.routes = JSON.parse(sidebarStr)
      }else{
        this.axios.get('/api/role/menu/list').then(res=>{
          console.log(res);
          if(res.data.errcode==0){
            this.routes=res.data.data.list
            console.log(this.routes,'this.routes');
          }
        })
      }
    }
  },
  mounted(){
    // const route = this.$route
    //   const { meta, path } = route
    //   // console.log(123)
    // if(route.params){
    //     return path+route.params
    //     console.log(path+route.params,"path+route.params")
    //   }
    this.getRouter();
  }
}
</script>
